import * as authentication from "../actions/authentication";
import * as notifications from "../actions/notifications";

import Immutable from "seamless-immutable";

const defaultState = () => Immutable({
    notifications: {
        // [{
        //     "notificationId": 0,
        //     "fromDate": "2019-09-10T12:46:05.744Z",
        //     "toDate": "2019-09-10T12:46:05.744Z",
        //     "subject": "string",
        //     "body": "string",
        //     "displayPopup": true,
        //     "priority": 0,
        //     "confirmedDate": "2019-09-10T12:46:05.744Z",
        //     "recipientType": 0
        // }]
    },
    loading: false
});

/**
 * 
 * @param {Object} state 
 * @param {{type: String}} action 
 * @returns {Object}
 */
export default function(state = defaultState(), action) {
    switch (action.type) {
    case notifications.NOTIFICATIONS_LOADING:
        return state.merge({
            loading: true
        });
    case notifications.NOTIFICATIONS_LOADED:
        return state.merge({
            loading: false,
            notifications: action.notifications
        }, {
            deep: true
        });
    case notifications.NOTIFICATIONS_FAILED_TO_LOAD:
        return state.merge({
            loading: false
        });
    case notifications.NOTIFICATION_UPDATE_CONFIRMED_DATE:
        return state.merge({
            notifications: {
                [action.notificationId]: {
                    confirmedDate: action.date,
                    dismissedOnClient: true
                }
            }
        }, {
            deep: true
        });
    case notifications.NOTIFICATION_DISMISSED:
        return state.merge({
            notifications: {
                [action.notificationId]: {
                    dismissedOnClient: true
                }
            }
        }, {
            deep: true
        });
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}